// extracted by mini-css-extract-plugin
export default {"component":"AlertAllStylistsOff_component__msGCi","closeButton":"AlertAllStylistsOff_closeButton__tCJyC"};